(function () {
    'use strict';

    angular
        .module('homeMyTasksControllers')
        .controller('MyTasksControlCertificationController', Controller);

    Controller.$inject = ['$scope', '$state', 'commonAricService'];

    function Controller($scope, $state, commonAricService) {

        // Get Certifiaction Tasks
        commonAricService
            .getCertificationTasks()
            .then(function (task) {
                $scope.tasksCountByName.controlCertification = task.NbTasks;
            });

        // With Tasks
        $scope.withTasks = function () {
            if (_.isUndefined($scope.tasksCountByName.controlCertification)) return;

            return $scope.tasksCountByName.controlCertification;
        };

        // Go To Control Certification
        $scope.goToControlCertification = function () {
            $state.go('aricCertification.user', { ItemPersonID: $scope.authenticatedUser.ItemPersonID });
        };
    }
})();